import api from "./api";

export const signup = async (userData) => {
  const response = await api.post("/auth/signup", userData);
  return response.data;
};
export const signin = async (userData) => {
  const response = await api.post("/auth/login", userData);
  return response;
};

export const authMethod = async () => {
  const response = await api.get("/auth/authmethod");
  return response;
};

export const sendPasswordResetEmail = async (email) => {
  try {
    const response = await api.post("/auth/requestPasswordReset", { "identifier": email });
    return response.data?.message || "Password reset email sent";
  } catch (error) {
    const message =
      error.response?.data?.message || error.response?.data?.error || error.message;
    throw new Error(message);
  }
};

export const confirmPasswordReset = async (token, newPassword) => {
  try {
    const response = await api.post("/auth/confirmPasswordReset", {
      token,
      newPassword,
    });
    return response.data?.message || "Password has been reset";
  } catch (error) {
    const message =
      error.response?.data?.message || error.response?.data?.error || error.message;
    throw new Error(message);
  }
};
